"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_redux_1 = require("react-redux");
const selectors_1 = require("src/redux/sagas/selectors");
const pages_1 = __importDefault(require("./pages"));
// eslint-disable-next-line max-statements, complexity
const mapStateToProps = (state, ownProps) => {
    const { theme, vendorLabel: { enable: enableVendorLabel }, buttonNext: { theme: buttonTheme, size: buttonNextSize }, skipButton: { enable: isShowSkipButton } } = (0, selectors_1.getConfig)(state);
    const { pages, survey, questions } = state;
    const { retpath } = survey;
    const isFinished = survey.finish;
    const isInited = survey.inited;
    const isScreenout = survey.screenout;
    // До инициализации считаем, что ждем ответа от сервера
    const status = isInited ? survey.status : 202;
    const { slug, queryString } = ownProps;
    const { list, currentPage } = pages;
    const isNextButtonEnabled = (0, selectors_1.getNextButtonEnabled)(state);
    const isPollStarted = (0, selectors_1.getIsPollStarted)(state);
    const pageNumber = (0, selectors_1.getCurrentPage)(state);
    const isCurrentPageUxAnswered = (0, selectors_1.getCurrentPageUxAnswered)(state);
    const surveyPreset = (0, selectors_1.getSurveyPreset)(state);
    const params = {
        pages: list,
        questions,
        currentPage,
        queryString,
        status,
        slug,
        retpath,
        isFinished,
        inited: survey.inited,
        reason: survey.reason,
        isNextButtonEnabled,
        theme,
        enableVendorLabel,
        buttonTheme,
        buttonNextSize,
        isShowSkipButton,
        isPollStarted,
        pageNumber,
        isCurrentPageUxAnswered,
        surveyPreset
    };
    // Если есть станицы для показа
    if (currentPage !== -1) {
        // @ts-expect-error TS(2551): Property 'page' does not exist on type '{ pages: a... Remove this comment to see the full error message
        params.page = list[currentPage];
    }
    // Если страницы закончились и установлен retpath
    // выставляем код 302 (редирект)
    if (retpath && (currentPage === -1 || isScreenout)) {
        params.status = 302;
    }
    return params;
};
exports.default = (0, react_redux_1.connect)(mapStateToProps)(pages_1.default);
